import ContentInformationApi from '@app/api/public/ContentInformationApi';
import { useMutation, useQueryClient } from 'react-query';
import { memberInformationQueryKeys } from './memberInformationQueries';

type Variables = { id: number };

const useSetInformationAsDraft = () => {
    const client = useQueryClient();
    return useMutation(
        (varables: Variables) => {
            return ContentInformationApi.setInformationAsDraft(varables.id);
        },
        {
            onSettled: (data, error, varables) => {
                client.invalidateQueries(memberInformationQueryKeys.lists());
                client.invalidateQueries(memberInformationQueryKeys.detail(varables.id));
            },
        }
    );
};

export default useSetInformationAsDraft;
